import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Suppress ResizeObserver loop errors - these are benign
const errorHandler = (e) => {
  if (/^ResizeObserver loop/.test(e.message || '')) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
};
window.addEventListener('error', errorHandler);

// Recover from stale code-split chunks after a redeploy. A lazy import() that
// 404s (its hashed chunk was replaced by a newer build) throws ChunkLoadError
// and blanks the route. Reload once to pull the current index.html + chunks;
// the sessionStorage guard prevents a reload loop if the chunk is truly gone.
const RELOAD_FLAG = 'chunk-reload-attempted';
const isChunkLoadError = (err, message) =>
  err?.name === 'ChunkLoadError' ||
  /Loading chunk [\d]+ failed/i.test(message || '') ||
  /Loading CSS chunk [\d]+ failed/i.test(message || '');

const recoverFromChunkError = (err, message) => {
  if (!isChunkLoadError(err, message)) return;
  if (sessionStorage.getItem(RELOAD_FLAG)) return;
  sessionStorage.setItem(RELOAD_FLAG, '1');
  window.location.reload();
};

window.addEventListener('error', (e) => recoverFromChunkError(e.error, e.message));
window.addEventListener('unhandledrejection', (e) =>
  recoverFromChunkError(e.reason, e.reason?.message)
);
// Clear the guard once the app has mounted successfully so a future stale
// chunk in the same tab can still trigger one recovery reload.
window.addEventListener('load', () => sessionStorage.removeItem(RELOAD_FLAG));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorkerRegistration.unregister();

reportWebVitals();
